/**
 * glas-signup-popup.js v3
 * Multi-step: Email → Channels+Phone (combined) → Done
 * Single list, locale as profile property, built-in A/B testing
 * ES5 for maximum theme compatibility
 */
(function() {
  'use strict';

  // ── Config (defaults, overridden by data attributes from section settings) ──
  var COOKIE_NAME = 'glas_signup_dismissed';
  var VARIANT_COOKIE = 'glas_popup_variant';
  var API_BASE = 'https://a.klaviyo.com/client';
  var API_REVISION = '2026-01-15';

  // Settings populated from data attributes in init()
  var CFG = {
    trigger: 'delay',
    delay: 8000,
    scrollPct: 30,
    dismissDays: 7,
    completeDays: 365,
    excludePages: '/cart,/checkout',
    showWhatsapp: true,
    showSms: true,
    showBirthday: false,
    abEnabled: false,
    mobileOnly: false,
    desktopOnly: false
  };

  var VARIANTS = {
    A: { code: 'GLASGIFT', weight: 100 },
    B: { code: 'GLASGIFT', weight: 0 }
  };

  // ── i18n ──
  var STRINGS = {
    en: {
      email_heading: 'Hey \u2014 glad you found us',
      email_subtext_A: 'Enter your email and we\u2019ll add a <strong>GLAS gift bag (worth \u20ac49)</strong> to your cart with your first order.',
      email_subtext_B: 'Enter your email and we\u2019ll add a <strong>GLAS gift bag (worth \u20ac49)</strong> to your cart with your first order.',
      email_placeholder: 'Your email',
      continue: 'Continue',
      complete: 'Done',
      skip: 'Skip',
      email_consent: 'You can unsubscribe at any time.',
      channel_heading: 'Stay in the loop',
      channel_subtext: 'New models drop regularly. Choose how you want to stay in the loop.',
      wa_label: 'WhatsApp', wa_desc: 'New collections, a few times a year',
      sms_label: 'SMS', sms_desc: 'We rarely send. But when we do, it\u2019s worth it.',
      phone_heading: 'Your number',
      phone_subtext: 'We\u2019re careful with your number. Unsubscribe anytime.',
      phone_placeholder: 'Phone number',
      phone_consent: 'By continuing you consent to marketing via SMS/WhatsApp. Unsubscribe anytime.',
      bday_heading: 'When\u2019s your birthday?',
      bday_subtext: 'A gift is waiting for you on your day.',
      done_heading: 'Welcome.',
      done_subtext: 'Your GLAS gift bag has been added to your cart.',
      done_btn: 'Start shopping \u2192',
      copy_hint: 'Tap to copy',
      copied: 'Copied!',
      day: 'Day',
      month: 'Month',
      year: 'Year',
      months: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
      social_proof: 'Join 47,000+ GLAS owners',
      email_cta: 'Get my gift',
      err_email: 'Please enter a valid email address.',
      err_phone: 'Please enter a valid phone number.',
      err_bday: 'Please fill in your birthday.',
      err_generic: 'Something went wrong. Please try again.'
    },
    sv: {
      email_heading: 'Hej \u2014 kul att du hittade hit',
      email_subtext_A: 'Ange din e-post s\u00e5 l\u00e4gger vi en <strong>GLAS gift bag (v\u00e4rd 599 kr)</strong> i din varukorg med din f\u00f6rsta order.',
      email_subtext_B: 'Ange din e-post s\u00e5 l\u00e4gger vi en <strong>GLAS gift bag (v\u00e4rd 599 kr)</strong> i din varukorg med din f\u00f6rsta order.',
      email_placeholder: 'Din e-post',
      continue: 'Forts\u00e4tt',
      complete: 'Klart',
      skip: 'Hoppa \u00f6ver',
      email_consent: 'Du kan avsluta n\u00e4r du vill.',
      channel_heading: 'H\u00e5ll dig uppdaterad',
      channel_subtext: 'Nya modeller landar regelb\u00fcdet. V\u00e4lj hur du vill ha koll.',
      wa_label: 'WhatsApp', wa_desc: 'Nya modeller, ett par g\u00e5nger om \u00e5ret',
      sms_label: 'SMS', sms_desc: 'Vi skickar s\u00e4llan. Men n\u00e4r vi g\u00f6r det \u00e4r det v\u00e4rt det.',
      phone_heading: 'Ditt nummer',
      phone_subtext: 'Vi \u00e4r sparsamma med ditt nummer. Du kan avsluta n\u00e4r du vill.',
      phone_placeholder: 'Telefonnummer',
      phone_consent: 'Genom att forts\u00e4tta godk\u00e4nner du marknadsf\u00f6ring via SMS/WhatsApp. Avsluta n\u00e4r du vill.',
      bday_heading: 'N\u00e4r fyller du \u00e5r?',
      bday_subtext: 'Det v\u00e4ntar en g\u00e5va p\u00e5 din dag.',
      done_heading: 'V\u00e4lkommen.',
      done_subtext: 'Din GLAS gift bag ligger i varukorgen.',
      done_btn: 'Forts\u00e4tt shoppa \u2192',
      copy_hint: 'Tryck f\u00f6r att kopiera',
      copied: 'Kopierad!',
      day: 'Dag',
      month: 'M\u00e5nad',
      year: '\u00c5r',
      months: ['Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
      social_proof: 'G\u00e5 med 47 000+ GLAS-\u00e4gare',
      email_cta: 'H\u00e4mta min g\u00e5va',
      err_email: 'Ange en giltig e-postadress.',
      err_phone: 'Ange ett giltigt telefonnummer.',
      err_bday: 'Fyll i din f\u00f6delsedag.',
      err_generic: 'N\u00e5got gick fel. F\u00f6rs\u00f6k igen.'
    },
    de: {
      email_heading: 'Sch\u00f6n, dass du hier bist',
      email_subtext_A: 'Gib deine E-Mail an und wir legen eine <strong>GLAS gift bag (Wert 49\u20ac)</strong> in deinen Warenkorb \u2014 mit deiner ersten Bestellung.',
      email_subtext_B: 'Gib deine E-Mail an und wir legen eine <strong>GLAS gift bag (Wert 49\u20ac)</strong> in deinen Warenkorb \u2014 mit deiner ersten Bestellung.',
      email_placeholder: 'Deine E-Mail',
      continue: 'Weiter',
      complete: 'Fertig',
      skip: '\u00dcberspringen',
      email_consent: 'Du kannst dich jederzeit abmelden.',
      channel_heading: 'Bleib auf dem Laufenden',
      channel_subtext: 'Neue Modelle erscheinen regelm\u00e4\u00dfig. W\u00e4hl, wie du es erfahren m\u00f6chtest.',
      wa_label: 'WhatsApp', wa_desc: 'Neue Kollektionen, ein paar Mal im Jahr',
      sms_label: 'SMS', sms_desc: 'Wir schreiben selten. Aber wenn, lohnt es sich.',
      phone_heading: 'Deine Nummer',
      phone_subtext: 'Wir gehen sparsam mit deiner Nummer um. Jederzeit abmeldbar.',
      phone_placeholder: 'Telefonnummer',
      phone_consent: 'Durch Fortfahren stimmst du Marketing per SMS/WhatsApp zu. Jederzeit abmeldbar.',
      bday_heading: 'Wann hast du Geburtstag?',
      bday_subtext: 'An deinem Tag wartet ein Geschenk auf dich.',
      done_heading: 'Willkommen.',
      done_subtext: 'Deine GLAS gift bag liegt im Warenkorb.',
      done_btn: 'Weiter shoppen \u2192',
      copy_hint: 'Zum Kopieren tippen',
      copied: 'Kopiert!',
      day: 'Tag',
      month: 'Monat',
      year: 'Jahr',
      months: ['Jan','Feb','M\u00e4r','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez'],
      social_proof: 'Schlie\u00dfe dich 47.000+ GLAS-Besitzern an',
      email_cta: 'Geschenk sichern',
      err_email: 'Bitte gib eine g\u00fcltige E-Mail-Adresse ein.',
      err_phone: 'Bitte gib eine g\u00fcltige Telefonnummer ein.',
      err_bday: 'Bitte gib deinen Geburtstag ein.',
      err_generic: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.'
    },
    nl: {
      email_heading: 'Hoi \u2014 fijn dat je er bent',
      email_subtext_A: 'Geef je e-mail op en we voegen een <strong>GLAS gift bag (ter waarde van \u20ac49)</strong> toe aan je winkelwagen \u2014 bij je eerste bestelling.',
      email_subtext_B: 'Geef je e-mail op en we voegen een <strong>GLAS gift bag (ter waarde van \u20ac49)</strong> toe aan je winkelwagen \u2014 bij je eerste bestelling.',
      email_placeholder: 'Je e-mail',
      continue: 'Verder',
      complete: 'Klaar',
      skip: 'Overslaan',
      email_consent: 'Je kunt je op elk moment afmelden.',
      channel_heading: 'Blijf op de hoogte',
      channel_subtext: 'Nieuwe modellen verschijnen regelmatig. Kies hoe je op de hoogte blijft.',
      wa_label: 'WhatsApp', wa_desc: 'Nieuwe collecties, een paar keer per jaar',
      sms_label: 'SMS', sms_desc: 'We sturen zelden iets. Maar als we dat doen, is het de moeite waard.',
      phone_heading: 'Je nummer',
      phone_subtext: 'We gaan zorgvuldig om met je nummer. Afmelden wanneer je wil.',
      phone_placeholder: 'Telefoonnummer',
      phone_consent: 'Door verder te gaan ga je akkoord met marketing via SMS/WhatsApp. Afmelden wanneer je wil.',
      bday_heading: 'Wanneer ben je jarig?',
      bday_subtext: 'Op jouw dag wacht er een cadeau.',
      done_heading: 'Welkom.',
      done_subtext: 'Je GLAS gift bag zit in je winkelwagen.',
      done_btn: 'Verder winkelen \u2192',
      copy_hint: 'Tik om te kopi\u00ebren',
      copied: 'Gekopieerd!',
      day: 'Dag',
      month: 'Maand',
      year: 'Jaar',
      months: ['Jan','Feb','Mrt','Apr','Mei','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
      social_proof: 'Sluit je aan bij 47.000+ GLAS-eigenaren',
      email_cta: 'Ontvang mijn cadeau',
      err_email: 'Voer een geldig e-mailadres in.',
      err_phone: 'Voer een geldig telefoonnummer in.',
      err_bday: 'Vul je verjaardag in.',
      err_generic: 'Er ging iets mis. Probeer het opnieuw.'
    },
    nb: {
      email_heading: 'Hei \u2014 hyggelig at du fant oss',
      email_subtext_A: 'Oppgi e-posten din, s\u00e5 legger vi en <strong>GLAS gift bag (verdt 499 kr)</strong> i handlekurven din \u2014 med din f\u00f8rste bestilling.',
      email_subtext_B: 'Oppgi e-posten din, s\u00e5 legger vi en <strong>GLAS gift bag (verdt 499 kr)</strong> i handlekurven din \u2014 med din f\u00f8rste bestilling.',
      email_placeholder: 'Din e-post',
      continue: 'Fortsett',
      complete: 'Ferdig',
      skip: 'Hopp over',
      email_consent: 'Du kan melde deg av n\u00e5r som helst.',
      channel_heading: 'Hold deg oppdatert',
      channel_subtext: 'Nye modeller lanseres jevnlig. Velg hvordan du vil f\u00f8lge med.',
      wa_label: 'WhatsApp', wa_desc: 'Nye kolleksjoner, et par ganger i \u00e5ret',
      sms_label: 'SMS', sms_desc: 'Vi sender sjelden. Men n\u00e5r vi gj\u00f8r det, er det verdt det.',
      phone_heading: 'Ditt nummer',
      phone_subtext: 'Vi er forsiktige med nummeret ditt. Du kan melde deg av n\u00e5r du vil.',
      phone_placeholder: 'Telefonnummer',
      phone_consent: 'Ved \u00e5 fortsette samtykker du til markedsf\u00f8ring via SMS/WhatsApp. Avslutt n\u00e5r du vil.',
      bday_heading: 'N\u00e5r fyller du \u00e5r?',
      bday_subtext: 'En gave venter p\u00e5 din dag.',
      done_heading: 'Velkommen.',
      done_subtext: 'Din GLAS gift bag ligger i handlekurven.',
      done_btn: 'Fortsett \u00e5 handle \u2192',
      copy_hint: 'Trykk for \u00e5 kopiere',
      copied: 'Kopiert!',
      day: 'Dag',
      month: 'M\u00e5ned',
      year: '\u00c5r',
      months: ['Jan','Feb','Mar','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Des'],
      social_proof: 'Bli med 47 000+ GLAS-eiere',
      email_cta: 'F\u00e5 min gave',
      err_email: 'Vennligst skriv inn en gyldig e-postadresse.',
      err_phone: 'Vennligst skriv inn et gyldig telefonnummer.',
      err_bday: 'Vennligst fyll inn bursdagen din.',
      err_generic: 'Noe gikk galt. Pr\u00f8v igjen.'
    },
    fi: {
      email_heading: 'Hei \u2014 kiva kun l\u00f6ysit meid\u00e4t',
      email_subtext_A: 'Anna s\u00e4hk\u00f6postiosoitteesi, niin lis\u00e4\u00e4mme <strong>GLAS gift bagin (arvo 49\u20ac)</strong> ostoskoriisi ensimm\u00e4isen tilauksesi yhteydess\u00e4.',
      email_subtext_B: 'Anna s\u00e4hk\u00f6postiosoitteesi, niin lis\u00e4\u00e4mme <strong>GLAS gift bagin (arvo 49\u20ac)</strong> ostoskoriisi ensimm\u00e4isen tilauksesi yhteydess\u00e4.',
      email_placeholder: 'S\u00e4hk\u00f6postisi',
      continue: 'Jatka',
      complete: 'Valmis',
      skip: 'Ohita',
      email_consent: 'Voit peruuttaa koska tahansa.',
      channel_heading: 'Pysy ajan tasalla',
      channel_subtext: 'Uusia malleja tulee s\u00e4\u00e4nn\u00f6llisesti. Valitse, miten haluat pys\u00e4\u00e4 ajan tasalla.',
      wa_label: 'WhatsApp', wa_desc: 'Uudet mallistot, muutama kerta vuodessa',
      sms_label: 'SMS', sms_desc: 'L\u00e4het\u00e4mme harvoin. Mutta kun l\u00e4het\u00e4mme, se on sen arvoista.',
      phone_heading: 'Numerosi',
      phone_subtext: 'K\u00e4yt\u00e4mme numeroasi harkiten. Voit peruuttaa koska tahansa.',
      phone_placeholder: 'Puhelinnumero',
      phone_consent: 'Jatkamalla hyv\u00e4ksyt markkinoinnin SMS/WhatsApp-kanavilla. Peruuta koska tahansa.',
      bday_heading: 'Milloin on syntymp\u00e4iv\u00e4si?',
      bday_subtext: 'Sinulle odottaa lahja p\u00e4iv\u00e4n\u00e4si.',
      done_heading: 'Tervetuloa.',
      done_subtext: 'GLAS gift bag on lis\u00e4tty ostoskoriisi.',
      done_btn: 'Jatka ostoksia \u2192',
      copy_hint: 'Kopioi napauttamalla',
      copied: 'Kopioitu!',
      day: 'P\u00e4iv\u00e4',
      month: 'Kuukausi',
      year: 'Vuosi',
      months: ['Tammi','Helmi','Maalis','Huhti','Touko','Kes\u00e4','Hein\u00e4','Elo','Syys','Loka','Marras','Joulu'],
      social_proof: 'Liity 47 000+ GLAS-omistajaan',
      email_cta: 'Hae lahjani',
      err_email: 'Anna kelvollinen s\u00e4hk\u00f6postiosoite.',
      err_phone: 'Anna kelvollinen puhelinnumero.',
      err_bday: 'T\u00e4yt\u00e4 syntymp\u00e4iv\u00e4si.',
      err_generic: 'Jokin meni pieleen. Yrit\u00e4 uudelleen.'
    },
    da: {
      email_heading: 'Hej \u2014 fedt at du fandt os',
      email_subtext_A: 'Indtast din e-mail, s\u00e5 l\u00e6gger vi en <strong>GLAS gift bag (v\u00e6rdi 349 kr)</strong> i din indk\u00f8bskurv \u2014 med din f\u00f8rste bestilling.',
      email_subtext_B: 'Indtast din e-mail, s\u00e5 l\u00e6gger vi en <strong>GLAS gift bag (v\u00e6rdi 349 kr)</strong> i din indk\u00f8bskurv \u2014 med din f\u00f8rste bestilling.',
      email_placeholder: 'Din e-mail',
      continue: 'Forts\u00e6t',
      complete: 'F\u00e6rdig',
      skip: 'Spring over',
      email_consent: 'Du kan framelde dig n\u00e5r som helst.',
      channel_heading: 'Hold dig opdateret',
      channel_subtext: 'Nye modeller lanceres l\u00f8bende. V\u00e6lg hvordan du vil f\u00f8lge med.',
      wa_label: 'WhatsApp', wa_desc: 'Nye kollektioner, et par gange om \u00e5ret',
      sms_label: 'SMS', sms_desc: 'Vi sender sj\u00e6ldent. Men n\u00e5r vi g\u00f8r det, er det det v\u00e6rd.',
      phone_heading: 'Dit nummer',
      phone_subtext: 'Vi er forsigtige med dit nummer. Afmeld dig n\u00e5r som helst.',
      phone_placeholder: 'Telefonnummer',
      phone_consent: 'Ved at forts\u00e6tte accepterer du markedsf\u00f8ring via SMS/WhatsApp. Afmeld n\u00e5r som helst.',
      bday_heading: 'Hvorn\u00e5r har du f\u00f8dselsdag?',
      bday_subtext: 'En gave venter p\u00e5 din dag.',
      done_heading: 'Velkommen.',
      done_subtext: 'Din GLAS gift bag er lagt i indk\u00f8bskurven.',
      done_btn: 'Forts\u00e6t med at handle \u2192',
      copy_hint: 'Tryk for at kopiere',
      copied: 'Kopieret!',
      day: 'Dag',
      month: 'M\u00e5ned',
      year: '\u00c5r',
      months: ['Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
      social_proof: 'Bliv en del af 47.000+ GLAS-ejere',
      email_cta: 'F\u00e5 min gave',
      err_email: 'Indtast venligst en gyldig e-mailadresse.',
      err_phone: 'Indtast venligst et gyldigt telefonnummer.',
      err_bday: 'Udfyld venligst din f\u00f8dselsdag.',
      err_generic: 'Noget gik galt. Pr\u00f8v igen.'
    }
  };

  // ── State ──
  var root = null;
  var companyId = '';
  var emailList = '';
  var smsList = '';
  var waList = '';
  var phonePrefix = '';
  var locale = 'en';
  var country = '';
  var currentStep = 1;
  var storedEmail = '';
  var selectedChannels = {};
  var variant = 'A';
  var strings = {};

  // ── Helpers ──

  function getCookie(name) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var c = cookies[i].trim();
      if (c.indexOf(name + '=') === 0) return c.substring(name.length + 1);
    }
    return null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getRoot() {
    if (!root) root = document.getElementById('glasSignupPopup');
    return root;
  }

  function t(key) {
    return strings[key] || (STRINGS.en[key] || key);
  }

  // ── A/B variant assignment ──

  function assignVariant() {
    var saved = getCookie(VARIANT_COOKIE);
    if (saved && VARIANTS[saved]) return saved;
    var rand = Math.random() * 100;
    var cumulative = 0;
    var chosen = 'A';
    for (var v in VARIANTS) {
      cumulative += VARIANTS[v].weight;
      if (rand < cumulative) { chosen = v; break; }
    }
    setCookie(VARIANT_COOKIE, chosen, 365);
    return chosen;
  }

  // ── i18n application ──

  function applyStrings() {
    var el = getRoot();
    if (!el) return;

    // Text content elements
    var els = el.querySelectorAll('[data-i18n]');
    for (var i = 0; i < els.length; i++) {
      var key = els[i].getAttribute('data-i18n');
      // Special handling for email_subtext — use variant-specific key
      if (key === 'email_subtext') {
        els[i].innerHTML = t('email_subtext_' + variant);
      } else {
        var val = t(key);
        if (val) els[i].innerHTML = val;
      }
    }

    // Placeholders
    var placeholders = el.querySelectorAll('[data-i18n-placeholder]');
    for (var j = 0; j < placeholders.length; j++) {
      var pk = placeholders[j].getAttribute('data-i18n-placeholder');
      placeholders[j].placeholder = t(pk);
    }

    // Discount code removed — gift fulfilled by warehouse
  }

  // ── Display ──

  function isKlaviyoSubscriber() {
    // Klaviyo.js sets __kla_id cookie when a browser is identified (i.e. has
    // previously submitted an email). Not 100% proof of subscription status but
    // a strong enough proxy to suppress the popup for known profiles.
    var kla = getCookie('__kla_id');
    if (!kla) return false;
    try {
      var decoded = JSON.parse(atob(kla));
      return !!(decoded && decoded['$email']);
    } catch(e) {
      return !!kla; // cookie exists but unreadable — treat as identified
    }
  }

  function shouldShow() {
    if (getCookie(COOKIE_NAME)) return false;
    if (isKlaviyoSubscriber()) return false;
    try { if (localStorage.getItem('glas_signup_done')) return false; } catch(e) {}

    var isMobile = window.innerWidth < 768;
    if (CFG.mobileOnly && !isMobile) return false;
    if (CFG.desktopOnly && isMobile) return false;

    var path = window.location.pathname;
    if (path.indexOf('/checkout') !== -1) return false;
    var excludes = CFG.excludePages.split(',');
    for (var i = 0; i < excludes.length; i++) {
      var ex = excludes[i].trim();
      if (ex && path.indexOf(ex) !== -1) return false;
    }

    var el = getRoot();
    if (el) {
      var tmpl = el.getAttribute('data-template') || '';
      if (tmpl === 'bundle-lp') return false;
    }
    return true;
  }

  function toggleOverlappingWidgets(hide) {
    var selectors = [
      '.pd-cookie-banner-window',
      '#pd-cp-preferences',
      '[id^="mount-floating-engagement"]',
      '[id^="chat-button"]',
      '[id^="chat-campaigns"]',
      '[id^="chat-input"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var els = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < els.length; j++) {
        els[j].style.display = hide ? 'none' : '';
      }
    }
  }

  function showPopup() {
    var el = getRoot();
    if (!el) return;
    toggleOverlappingWidgets(true);
    document.body.classList.add('glas-popup-open');
    el.setAttribute('aria-hidden', 'false');
    el.offsetHeight; // force reflow
    el.classList.add('glas-popup--visible');
    document.body.style.overflow = 'hidden';
    trackEvent('Popup Shown', { variant: variant, locale: locale, page: window.location.pathname });
    // GA4 dataLayer event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'popup_shown', popup_version: 'v2' });
    emitKlaviyoFormsEvent('open', {});
  }

  function hidePopup() {
    var el = getRoot();
    if (!el) return;
    el.classList.remove('glas-popup--visible');
    setTimeout(function() {
      el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('glas-popup-open');
      toggleOverlappingWidgets(false);
    }, 300);
    document.body.style.overflow = '';
    emitKlaviyoFormsEvent('close', {});
  }

  function dismissPopup(isDone) {
    var days = isDone ? CFG.completeDays : CFG.dismissDays;
    setCookie(COOKIE_NAME, '1', days);
    hidePopup();
  }

  // ── Step navigation ──

  function showStep(step) {
    var el = getRoot();
    if (!el) return;
    currentStep = step;

    var steps = el.querySelectorAll('.glas-popup-step');
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.remove('active');
      if (steps[i].getAttribute('data-step') === String(step)) {
        steps[i].classList.add('active');
      }
    }

    var dots = el.querySelectorAll('.glas-popup-dot');
    for (var j = 0; j < dots.length; j++) {
      var dotVal = dots[j].getAttribute('data-dot');
      if (step === 'done') {
        dots[j].classList.add('active');
      } else if (dotVal === 'done') {
        dots[j].classList.remove('active');
      } else {
        var dn = parseInt(dotVal, 10);
        var stepNum = parseInt(step, 10);
        if (dn <= stepNum) {
          dots[j].classList.add('active');
        } else {
          dots[j].classList.remove('active');
        }
      }
    }

    if (step === 'done') {
      trackEvent('Popup Completed', { variant: variant, locale: locale });
    }
  }

  // ── klaviyoForms event emitter (GTM/GA4 compatibility) ──

  function emitKlaviyoFormsEvent(type, meta) {
    try {
      window.dispatchEvent(new CustomEvent('klaviyoForms', {
        detail: { type: type, formId: 'glas-popup-v2', metaData: meta || {} }
      }));
    } catch(e) {}
  }

  // ── Tracking ──

  function trackEvent(name, props) {
    var body = {
      data: {
        type: 'event',
        attributes: {
          metric: { data: { type: 'metric', attributes: { name: name } } },
          properties: props || {},
          profile: { data: { type: 'profile', attributes: {} } }
        }
      }
    };
    // Attach email if known, otherwise use anonymous tracking
    if (storedEmail) {
      body.data.attributes.profile.data.attributes.email = storedEmail;
    }
    // Use klaviyoPost for proper CORS handling (fire-and-forget)
    klaviyoPost('/events/', body, function() {});
  }

  // ── Validation ──

  function isValidEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); }
  function isValidPhone(phone) { return phone.replace(/\D/g, '').length >= 6; }

  function showError(form, msg) {
    var errEl = form.querySelector('.glas-popup-error');
    if (errEl) errEl.textContent = msg;
  }
  function clearError(form) {
    var errEl = form.querySelector('.glas-popup-error');
    if (errEl) errEl.textContent = '';
    var inputs = form.querySelectorAll('.glas-popup-input');
    for (var i = 0; i < inputs.length; i++) inputs[i].classList.remove('error');
  }

  // ── Klaviyo API ──

  function klaviyoPost(endpoint, body, callback) {
    fetch(API_BASE + endpoint + '?company_id=' + companyId, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': API_REVISION },
      body: JSON.stringify(body)
    }).then(function(res) {
      callback(res.status === 202 || res.ok ? null : t('err_generic'));
    }).catch(function() {
      callback(t('err_generic'));
    });
  }

  function subscribeEmail(email, cb) {
    klaviyoPost('/subscriptions/', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'GLAS Popup v2',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  locale: locale,
                  country: country,
                  signup_variant: variant,
                  signup_source: 'popup_v2'
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: emailList } } }
      }
    }, cb);
  }

  function subscribeChannel(channel, phone, cb) {
    var listId = channel === 'whatsapp' ? waList : smsList;
    var subscriptions = {};
    if (channel === 'sms') {
      subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    } else if (channel === 'whatsapp') {
      subscriptions.whatsapp = { marketing: { consent: 'SUBSCRIBED' } };
    }
    klaviyoPost('/subscriptions/', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'GLAS Popup v2',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: storedEmail,
                phone_number: phone,
                subscriptions: subscriptions
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    }, cb);
  }

  // Birthday removed from popup — moved to post-purchase flow

  // ── Form handlers ──

  function handleEmailSubmit(e) {
    e.preventDefault();
    var form = e.target;
    var input = form.querySelector('input[name="email"]');
    var btn = form.querySelector('.glas-popup-btn');
    var email = input.value.trim();
    clearError(form);

    if (!email || !isValidEmail(email)) {
      input.classList.add('error');
      showError(form, t('err_email'));
      return;
    }

    btn.disabled = true;
    btn.textContent = '...';

    subscribeEmail(email, function(err) {
      if (err) {
        showError(form, err);
        btn.disabled = false;
        btn.textContent = t('continue');
        return;
      }
      storedEmail = email;
      setCookie(COOKIE_NAME, '1', CFG.completeDays);
      // Persistent localStorage flag for cross-session detection
      try { localStorage.setItem('glas_signup_done', '1'); } catch(e) {}
      trackEvent('Popup Email Submitted', { variant: variant, locale: locale });
      // GA4 dataLayer event
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'popup_email_submitted', popup_version: 'v2' });
      // Auto-add GLAS Gift to cart (variant 52757146042698, price €0)
      try {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: 52757146042698, quantity: 1 }] })
        });
      } catch(e) {}
      emitKlaviyoFormsEvent('submit', { '$email': email, stepName: 'email', variant: variant });
      // Cookie browser session to Klaviyo profile for onsite tracking (Active on Site etc.)
      if (window.klaviyo && klaviyo.identify) {
        klaviyo.identify({ 'email': storedEmail });
      }
      // Skip to appropriate next step based on settings
      if (CFG.showWhatsapp || CFG.showSms) {
        showStep(2);
      } else {
        showStep('done');
      }
    });
  }

  function handleChannelsContinue() {
    // In v3 combined step, this is only called if no channel selected (skip-like)
    showStep('done');
  }

  // Show/hide phone section when channel is toggled
  function togglePhoneSection() {
    var hasSelection = selectedChannels.whatsapp || selectedChannels.sms;
    var phoneSection = document.getElementById('glasPopupPhoneSection');
    var channelsBtn = getRoot().querySelector('.glas-popup-btn--channels');
    if (phoneSection) {
      phoneSection.style.display = hasSelection ? '' : 'none';
    }
    // Hide the standalone "continue" button when phone section is visible (phone form has its own submit)
    if (channelsBtn) {
      channelsBtn.style.display = hasSelection ? 'none' : '';
    }
  }

  function handlePhoneSubmit(e) {
    e.preventDefault();
    var form = e.target;
    var input = form.querySelector('input[name="phone"]');
    var btn = form.querySelector('.glas-popup-btn');
    var phone = input.value.trim();
    clearError(form);

    if (!phone || !isValidPhone(phone)) {
      input.classList.add('error');
      showError(form, t('err_phone'));
      return;
    }

    var countrySelect = form.querySelector('.glas-popup-phone-country');
    var selectedPrefix = countrySelect ? countrySelect.value : phonePrefix;
    var cleaned = phone.replace(/^0+/, '');
    var fullPhone = cleaned.charAt(0) === '+' ? cleaned : selectedPrefix + cleaned;
    btn.disabled = true;
    btn.textContent = '...';

    var pending = 0;
    var errors = [];

    function done() {
      pending--;
      if (pending <= 0) {
        if (errors.length > 0) {
          showError(form, errors[0]);
          btn.disabled = false;
          btn.textContent = t('continue');
        } else {
          showStep('done');
        }
      }
    }

    if (selectedChannels.sms) {
      pending++;
      subscribeChannel('sms', fullPhone, function(err) { if (err) errors.push(err); done(); });
    }
    if (selectedChannels.whatsapp) {
      pending++;
      subscribeChannel('whatsapp', fullPhone, function(err) { if (err) errors.push(err); done(); });
    }

    if (pending === 0) showStep('done');
  }

  // handleBirthdaySubmit removed — birthday moved to post-purchase flow

  // ── Birthday selects ──

  // setupBirthdayInputs removed — birthday moved to post-purchase flow

  // ── Event binding ──

  function bindEvents() {
    var el = getRoot();
    if (!el) return;

    // Close
    var closeBtn = el.querySelector('.glas-popup-close');
    if (closeBtn) closeBtn.addEventListener('click', function() { dismissPopup(false); });

    // Overlay click
    el.addEventListener('click', function(e) { if (e.target === el) dismissPopup(false); });

    // Escape
    document.addEventListener('keydown', function(e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && getRoot().getAttribute('aria-hidden') === 'false') {
        dismissPopup(false);
      }
    });

    // Email form
    var emailForm = el.querySelector('[data-form="email"]');
    if (emailForm) emailForm.addEventListener('submit', handleEmailSubmit);

    // Channel picker
    var channelOpts = el.querySelectorAll('.glas-popup-channel-opt');
    for (var c = 0; c < channelOpts.length; c++) {
      channelOpts[c].addEventListener('click', function() {
        var ch = this.getAttribute('data-channel');
        this.classList.toggle('selected');
        selectedChannels[ch] = this.classList.contains('selected');
        this.setAttribute('aria-checked', String(selectedChannels[ch]));
        togglePhoneSection();
      });
      channelOpts[c].addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    }

    // Channels continue button
    var channelsBtn = el.querySelector('.glas-popup-btn--channels');
    if (channelsBtn) channelsBtn.addEventListener('click', handleChannelsContinue);

    // Phone form
    var phoneForm = el.querySelector('[data-form="phone"]');
    if (phoneForm) phoneForm.addEventListener('submit', handlePhoneSubmit);

    // Skip buttons
    var skipChannels = el.querySelector('.glas-popup-skip--channels');
    if (skipChannels) skipChannels.addEventListener('click', function() {
      showStep('done');
    });

    // Done button
    var doneBtn = el.querySelector('.glas-popup-btn--done');
    if (doneBtn) doneBtn.addEventListener('click', function() { dismissPopup(true); });

    // Copy code on tap/click
    var codeEl = el.querySelector('#glasPopupCode');
    if (codeEl) {
      function handleCopy() {
        var code = codeEl.textContent.trim();
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function() { showCopied(); });
        } else {
          // Fallback for older browsers
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          showCopied();
        }
        function showCopied() {
          codeEl.classList.add('copied');
          var hint = el.querySelector('.glas-popup-copy-hint');
          if (hint) hint.textContent = t('copied');
          setTimeout(function() {
            codeEl.classList.remove('copied');
            if (hint) hint.textContent = t('copy_hint');
          }, 2000);
        }
      }
      codeEl.addEventListener('click', handleCopy);
      codeEl.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleCopy(); }
      });
    }

  }

  // ── Init ──

  // ── Trigger handlers ──

  function setupTrigger() {
    var triggered = false;
    function fire() {
      if (triggered) return;
      triggered = true;
      showPopup();
    }

    var trigger = CFG.trigger;

    // Delay trigger
    if (trigger === 'delay' || trigger === 'delay+exit') {
      setTimeout(fire, CFG.delay);
    }

    // Scroll trigger
    if (trigger === 'scroll') {
      var onScroll = function() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (docHeight > 0 && (scrollTop / docHeight * 100) >= CFG.scrollPct) {
          fire();
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Exit intent trigger (desktop only — mouse leaves viewport top)
    if (trigger === 'exit' || trigger === 'delay+exit') {
      var onMouseLeave = function(e) {
        if (e.clientY <= 0) {
          fire();
          document.removeEventListener('mouseleave', onMouseLeave);
        }
      };
      // Small delay to avoid triggering on initial page load mouse movements
      setTimeout(function() {
        document.addEventListener('mouseleave', onMouseLeave);
      }, 2000);
    }
  }

  // ── Init ──

  function init() {
    var el = getRoot();
    if (!el) return;

    // Read Klaviyo config
    companyId = el.getAttribute('data-klaviyo-company') || '';
    emailList = el.getAttribute('data-email-list') || '';
    smsList = el.getAttribute('data-sms-list') || '';
    waList = el.getAttribute('data-wa-list') || '';
    phonePrefix = el.getAttribute('data-phone-prefix') || '+44';
    locale = el.getAttribute('data-locale') || 'en';
    country = el.getAttribute('data-country') || '';

    // Read section settings from data attributes
    CFG.trigger = el.getAttribute('data-trigger') || 'delay';
    CFG.delay = (parseInt(el.getAttribute('data-delay'), 10) || 8) * 1000;
    CFG.scrollPct = parseInt(el.getAttribute('data-scroll-pct'), 10) || 30;
    CFG.dismissDays = parseInt(el.getAttribute('data-dismiss-days'), 10) || 7;
    CFG.completeDays = parseInt(el.getAttribute('data-complete-days'), 10) || 365;
    CFG.excludePages = el.getAttribute('data-exclude-pages') || '/cart,/checkout';
    CFG.showWhatsapp = el.getAttribute('data-show-whatsapp') === 'true';
    CFG.showSms = el.getAttribute('data-show-sms') === 'true';
    CFG.showBirthday = el.getAttribute('data-show-birthday') === 'true';
    CFG.mobileOnly = el.getAttribute('data-mobile-only') === 'true';
    CFG.desktopOnly = el.getAttribute('data-desktop-only') === 'true';

    // A/B config
    var abEnabled = el.getAttribute('data-ab-enabled') === 'true';
    VARIANTS.A.code = el.getAttribute('data-variant-a-code') || 'GLAS10';
    VARIANTS.A.weight = parseInt(el.getAttribute('data-variant-a-weight'), 10) || 50;
    VARIANTS.B.code = el.getAttribute('data-variant-b-code') || 'FREESHIPGLAS';
    VARIANTS.B.weight = parseInt(el.getAttribute('data-variant-b-weight'), 10) || 50;

    // If A/B disabled, force variant A (100% traffic)
    if (!abEnabled) {
      variant = 'A';
      setCookie(VARIANT_COOKIE, 'A', 365);
    } else {
      variant = assignVariant();
    }

    // Shopify returns 'no' for Norwegian, STRINGS uses 'nb'
    if (locale === 'no') locale = 'nb';
    strings = STRINGS[locale] || STRINGS.en;

    applyStrings();
    bindEvents();

    if (!shouldShow()) return;
    setupTrigger();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
